module.exports = __webpack_public_path__ + "assets/icons/on-my-way-nonactive-emoji.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/on-my-way-nonactive-emoji.png
// module id = ./src/styles/icons/emojies/on-my-way-nonactive-emoji.png
// module chunks = 0